
(function pwdResetControllerDefinition() {

    'use strict';

    angular.module('PwdReset')
        .controller('PwdResetController', [
            '$scope', '$stateParams', '$state', '$translate', 'auth', 'alerts', 'login', 'errorsExtend',
            function pwdResetController($scope, $stateParams, $state, $translate, auth, alerts, login, errors) {

                $scope.firstTime = ($state.$current.name === 'pwd-first-time');

                if ($stateParams.code) {

                    $scope.perfil = {
                        code: $stateParams.code,
                        password: '',
                        confirmPassword: ''
                    };

                    $scope.save = function pwdResetResetPassword() {

                        if (!$scope.changePasswordForm.$valid) {
                            $scope.changePasswordForm.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return;
                        }

                        return auth.resetPassword($scope.perfil).then(function () {
                            $translate(['ResetPasswordOKPopupTitle', 'ResetPasswordOKPopup', 'ErrorOk'])
                                   .then(function (translated) {
                                       alerts.alert(translated.ResetPasswordOKPopupTitle,
                                           translated.ResetPasswordOKPopup,
                                           translated.ErrorOk);
                                   });
                            $state.go('inicio');
                        },
                        function (error) {
                            errors.showError(error);
                        });
                    };

                } else {
                    $state.go('inicio');
                }

            }
        ]);

})();